export const initialFieldValues = {
  name: '',
  birthdate: '',
};
